import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { InputNumberComponent } from "@components/input-number/input-number.component";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { from } from "rxjs";
import { BusyService } from "~app/common/components/busy/busy.service";
import { CommandService } from "~app/common/services/cqs/command.service";
import { CommandManager, ICommandManager } from "~app/common/services/cqs/commandManager";
import { FormBinderService } from "~app/common/services/form-binder.service";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { IValidationContext } from "~app/common/validation/IValidationContext";
import { IValidationScope } from "~app/common/validation/IValidationScope";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { SetAvstandNarmasteIndustriJusteratCommand } from "../commands/SetAvstandNarmasteIndustriJusteratCommand";
import { ArbetsorderService } from "../services/arbetsorder.service";
import { ArbetsorderHandelssortimentDetailsValidation } from "./arbetsorder-handelssortiment-details.validation";

@Component({
    selector: "rask-arbetsorder-handelssortiment-details",
    templateUrl: "./arbetsorder-handelssortiment-details.component.html",
    styleUrls: ["./arbetsorder-handelssortiment-details.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        InputNumberComponent,
        ButtonComponent
    ]
})
export class ArbetsorderHandelssortimentDetailsComponent implements OnInit {
    activeModal = inject(NgbActiveModal);
    data: {
        arbetsorderId: number;
        arbetsorderHandelssortimentId: number;
    };
    form = new UntypedFormGroup({
        avstandNarmasteIndustriJusterat: new UntypedFormControl()
    });
    validation: IValidationScope;
    validationContext: IValidationContext;
    vm: {
        avstandNarmasteIndustri: string;
        avstandNarmasteIndustriJusterat?: number;
    };

    private readonly arbetsorderService = inject(ArbetsorderService);
    private readonly busyService = inject(BusyService);
    private readonly commandManager: ICommandManager;
    private readonly commandService = inject(CommandService);
    private readonly formBinder = inject(FormBinderService);

    constructor() {
        this.commandManager = new CommandManager();
    }

    canSave() {
        return this.form && this.form.dirty && !this.form.invalid;
    }

    dismiss() {
        this.activeModal.close();
    }

    ngOnInit(): void {
        this.arbetsorderService.getArbetsorderHandelssortiment(this.data.arbetsorderId, this.data.arbetsorderHandelssortimentId)
            .subscribe((x) => {
                const ahs = x.arbetsorderHandelssortiment[0];
                this.vm = {
                    avstandNarmasteIndustri: !ObjectUtils.isNullOrUndefined(ahs.avstandNarmasteIndustri) ? `${ahs.avstandNarmasteIndustri}` : "",
                    avstandNarmasteIndustriJusterat: ahs.avstandNarmasteIndustriJusterat
                };

                this.createForm();
            });
    }

    save(): void {
        const avstandNarmasteIndustriJusterat = this.form.get("avstandNarmasteIndustriJusterat").value;

        this.commandManager.addOrUpdate(new SetAvstandNarmasteIndustriJusteratCommand(c => {
            c.arbetsorderHandelssortimentId = this.data.arbetsorderHandelssortimentId;
            c.avstandNarmasteIndustriJusterat = avstandNarmasteIndustriJusterat;
        }), c => c.arbetsorderHandelssortimentId === this.data.arbetsorderHandelssortimentId);

        const work = from(this.commandService.pushCommands(this.commandManager));
        this.busyService
            .addWork(work)
            .subscribe(() => {
                this.commandManager.clear();
                this.activeModal.close();
            });
    }

    private createForm(): void {
        this.form = this.formBinder.CreateGroup(this.vm);
        this.validationContext = ArbetsorderHandelssortimentDetailsValidation.init(this.vm);
        this.validationContext
            .scope(ValidationScopes.spara)
            .subscribe(v => { this.validation = v; });
        this.formBinder.attachValidation(this.validationContext.current, this.form);
        this.form.markAsPristine();
    }
}
